import React from "react";
import CookiesPanel$ from "@deosite/components-new/CookiesPanel";
import Button from "@deosite/components-new/buttons/Button";
import CheckboxSelectable from "../selectables/Checkbox";
import VerticalMenuWithContentToggle from "../VerticalMenuWithContentToggle";

const CookiesPanel = props => {
  const propsExt = {
    ...props,
    verticalMenuWithContentToggle: <VerticalMenuWithContentToggle />,
    checkboxSelectable: <CheckboxSelectable />,
    button: <Button data-test={"accept-cookies-button"} />,
    buttonLight: (
      <Button
        sx={{
          $outline: true
        }}
      />
    )
  };
  return <CookiesPanel$ {...propsExt} />;
};

export default CookiesPanel;
